<template>
    <div>

<!--    <div class="head_lh"></div>-->
    <div class="fxboex head">
        <div class="logo"><router-link to="/"/></div>
        <div class="head_rg">
            <router-link to="/coupon" class="tpcup">优惠</router-link>
            <template v-if="user">
                <router-link to="/cart" class="tpcart"/>
                <router-link to="/my" class="tpuser"><i></i>{{ user.name }}</router-link>
            </template>
            <router-link to="/login" class="tplogin" v-else>登录/注册</router-link>
<!--            <template v-if="user">-->
<!--&lt;!&ndash;                <span class="sign" title="已签到" v-if="user.is_sign && user.is_sign===true"><i></i>已签到</span>&ndash;&gt;-->
<!--&lt;!&ndash;                <span class="sign" title="签到送积分" v-else @click="toSign"><i></i>签到</span>&ndash;&gt;-->
<!--            </template>-->
<!--            <template v-else>-->
<!--&lt;!&ndash;               <span class="sign" title="签到送积分" @click="toSign"><i></i>签到</span>&ndash;&gt;-->
<!--            </template>-->

        </div>
    </div>

    </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
    name: "Header",
    computed: mapGetters(['isLogin', 'user']),
    data(){
        return {
            navList: [
                {
                    name: '首页',
                    url: '/'
                },
                {
                    name: '预测',
                    url: '/free'
                },
                {
                    name: '足球',
                    url: '/football'
                },
                {
                    name: '篮球',
                    url: '/baskball'
                },
                {
                    name: '专家',
                    url: '/expert'
                },
                {
                    name: '新闻',
                    url: '/news',
                    down: true
                },
                {
                    name: '比分',
                    url: 'http://www.s78999.com',
                    blank: true
                },
                {
                    name: '优惠',
                    url: '/coupon'
                },
            ]
        }
    },
    created() {
        let that = this
        //加载读取用户信息
        if(this.$store.state.token){
            this.$post(false, that.$api.getUserInfo).then(function (res) {
                if(res.code === 1){
                    that.$store.commit('SET_USER', res.data.user)
                }
                else{
                    that.$store.commit('LOGOUT')
                }
            })
        }
    },
    methods: {
        loginOut: function(){
            let that = this
            that.$dialog.confirm({
                title: '确认',
                message: '确定退出？',
            }).then( () => {
                that.$store.commit('LOGOUT')
            }).catch(()=>{})
        },
        toSign: function () {
            let that = this
            if(that.$route.path === '/login' || that.$route.path === '/register'){
                that.$toast('请先登录！')
                return
            }
            if(!that.isLogin){
                that.$store.commit('SHOW_LOGINPOP')
                return
            }
            that.$post(that.$api.sign).then(function (res) {
                if(res.code === 1){
                    that.$toast.success(res.msg)
                    let user = that.user
                    if(that.user === null) {
                        user = {}
                        // let user = JSON.parse(that.user)
                    }
                    user.is_sign = true
                    user.integral = res.data.integral
                    that.$store.commit('SET_USER', user)
                }
                else {
                    that.$toast.fail(res.msg)
                }
            })

        }
    }
}
</script>

<style scoped>
</style>
